import React, {FC} from 'react';
import {ReactSVG} from 'react-svg';

import {
	fax_phone,
	googleMaps,
	instagram,
	mail,
	mobile_phone,
	telegram,
	viber,
	whatsapp,
} from '../../assets';

import './style.scss';

type PropsTypes = {
	isOpenContacts: boolean;
	className?: string;
};

const ContactsModal: FC<PropsTypes> = ({isOpenContacts, className}) => {
	return (
		<div className={`contacts-wrapper ${isOpenContacts ? 'open' : ''} ${className || ''}`}>
			<p>ООО «Транспортно-логистическая компания ДиСав»</p>
			<p>Республика Беларусь, 220048, г. Минск, ул. Мясникова, 39, пом. 1</p>
			<p>УНП 193565898, ОКПО 505187885000</p>
			<div className="tel">
				<ReactSVG src={fax_phone} alt="fax_phone" className="tel__icon" />
				<a href="tel:+375173904417">+375 (17) 390-44-17</a>
			</div>
			<div className="mail">
				<ReactSVG src={mail} alt="mail" className="mail__icon" />
				<a href="mailto:office.disav@gmail.com">office.disav@gmail.com</a>
			</div>

			<h3>Директор:</h3>
			<p className="mb-0">Савостенко Ирина Владимировна</p>
			<div className="tel">
				<ReactSVG src={mobile_phone} alt="fax_phone" className="tel__icon" />
				<a href="tel:+375293255527">+375 (29) 325-55-27</a>
				<div className="social">
					<ReactSVG src={telegram} alt="Telegram" className="social__icon" />
					<ReactSVG src={viber} alt="Viber" className="social__icon" />
					<ReactSVG src={whatsapp} alt="WhatsApp" className="social__icon" />
				</div>
			</div>

			<h3>Менеджеры по перевозкам:</h3>
			<div className="tel">
				<ReactSVG src={mobile_phone} alt="fax_phone" className="tel__icon" />
				<a href="tel:++375293255571">+375 (29) 325-55-71</a>
				<div className="social">
					<ReactSVG src={telegram} alt="Telegram" className="social__icon" />
					<ReactSVG src={viber} alt="Viber" className="social__icon" />
					<ReactSVG src={whatsapp} alt="WhatsApp" className="social__icon" />
				</div>
			</div>
			<div className="tel">
				<ReactSVG src={mobile_phone} alt="fax_phone" className="tel__icon" />
				<a href="tel:+375445683555">+375 (44) 568-35-55</a>
				<div className="social">
					<ReactSVG src={telegram} alt="Telegram" className="social__icon" />
					<ReactSVG src={viber} alt="Viber" className="social__icon" />
					<ReactSVG src={whatsapp} alt="WhatsApp" className="social__icon" />
				</div>
			</div>

			<h3>Юридическая консультация:</h3>
			<div className="mail">
				<ReactSVG src={mail} alt="mail" className="mail__icon" />
				<a href="mailto:lawyer.disav@gmail.com">lawyer.disav@gmail.com</a>
			</div>

			<h3>Отзывы:</h3>
			<div className="reviews googleMaps">
				<ReactSVG src={googleMaps} alt="google maps reviews" className="googleMaps__icon" />
				<a
					href="https://maps.app.goo.gl/Y1aytuGhuCbZKvPu8"
					target="_blank"
					rel="noreferrer">
					Google Maps
				</a>
			</div>
			<div className="reviews instagram">
				<ReactSVG src={instagram} alt="instagram" className="instagram__icon" />
				<a
					href="https://instagram.com/tlc_disav?igshid=YmMyMTA2M2Y="
					target="_blank"
					rel="noreferrer">
					Instagram
				</a>
			</div>
			<div className="razrab">
				<a href="mailto:evenamf@gmail.com">Разработчик: evenamf@gmail.com</a>
			</div>
		</div>
	);
};

export default ContactsModal;
